"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchRefreshToken = exports.stytchLoadAuthenticationStateSaga = exports.stytchLoadAuthenticationState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
const storageManagement_1 = require("../tokens-storage/storageManagement");
const adaptStorage_1 = require("../tokens-storage/adaptStorage");
const stytchClearStoreSaga_1 = require("./stytchClearStoreSaga");
const stytchGetCurrentUserSaga_1 = require("./stytchGetCurrentUserSaga");
const stytchLoadingSlot_1 = require("./stytchLoadingSlot");
const stytchSetAuthenticatedSaga_1 = require("./stytchSetAuthenticatedSaga");
const stytchWarning_1 = require("./stytchWarning");
exports.stytchLoadAuthenticationState = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/LOAD_AUTHENTICATION');
function* stytchLoadAuthenticationStateSaga() {
    yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchClearWarnings)());
    yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
        slot: stytchLoadingSlot_1.StytchLoadingSlot.LOAD_AUTHENTICATION,
        loading: true,
    }));
    try {
        // const accessTokenStorage = yield* call(getAccessTokenStorage);
        // const accessToken = yield* call([accessTokenStorage, 'getAccessToken']);
        const storage = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'storage');
        const userServiceAddress = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'userServiceAddress');
        const adaptedStorage = (0, adaptStorage_1.adaptStorage)(storage);
        const accessToken = yield* (0, typed_redux_saga_1.call)(storageManagement_1.getAccessToken, adaptedStorage);
        if (accessToken) {
            const response = yield* (0, typed_redux_saga_1.call)(api_1.stytchFetchCurrentUser, accessToken, userServiceAddress);
            if (response.ok) {
                yield* (0, typed_redux_saga_1.put)((0, stytchGetCurrentUserSaga_1.stytchGetCurrentUser)({ accessToken }));
                yield* (0, typed_redux_saga_1.put)((0, stytchSetAuthenticatedSaga_1.stytchSetAuthenticated)(true));
            }
            else {
                const newAccessToken = yield* (0, typed_redux_saga_1.call)(stytchRefreshToken, accessToken);
                if (newAccessToken) {
                    yield* (0, typed_redux_saga_1.call)(storageManagement_1.setAccessToken, adaptedStorage, newAccessToken);
                    yield* (0, typed_redux_saga_1.put)((0, stytchGetCurrentUserSaga_1.stytchGetCurrentUser)({ accessToken: newAccessToken }));
                    yield* (0, typed_redux_saga_1.put)((0, stytchSetAuthenticatedSaga_1.stytchSetAuthenticated)(true));
                }
                else {
                    yield* (0, typed_redux_saga_1.call)(storageManagement_1.removeOldAccessToken, adaptedStorage);
                    yield* (0, typed_redux_saga_1.call)(storageManagement_1.removeAccessToken, adaptedStorage);
                    yield* (0, typed_redux_saga_1.put)((0, stytchClearStoreSaga_1.stytchClearStore)());
                }
            }
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchClearStoreSaga_1.stytchClearStore)());
        }
    }
    catch (e) {
        yield* (0, typed_redux_saga_1.put)((0, stytchClearStoreSaga_1.stytchClearStore)());
    }
    finally {
        yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
            slot: stytchLoadingSlot_1.StytchLoadingSlot.LOAD_AUTHENTICATION,
            loading: false,
        }));
    }
}
exports.stytchLoadAuthenticationStateSaga = stytchLoadAuthenticationStateSaga;
function* stytchRefreshToken(accessToken) {
    let newAccessToken = null;
    if (accessToken) {
        const userServiceAddress = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'userServiceAddress');
        const newAccessTokenResponse = yield* (0, typed_redux_saga_1.call)(api_1.stytchFetchRefreshToken, accessToken, userServiceAddress);
        if (newAccessTokenResponse.ok) {
            const newAccessTokenResponseJson = yield* (0, typed_redux_saga_1.call)([
                newAccessTokenResponse,
                'json',
            ]);
            newAccessToken = newAccessTokenResponseJson.session_jwt;
        }
    }
    return newAccessToken;
}
exports.stytchRefreshToken = stytchRefreshToken;
